<template>
  <div
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;"
    class="Kanit mx-auto bg-subpage-black1"
  >
    <!-- Header -->
    <Header
      :isHeaderFixed="false"
      :subpageLogoColor="'white'"
      :isMenuBlack="false"
    ></Header>

    <div style="padding-top: 6%;">
      <h3
        class="text-center mb-3"
        style="font-size: 24px; font-weight: 700; color: #FFF; letter-spacing: 1px;"
      >
        สะสมยอดซื้อ
      </h3>
    </div>

    <v-slide-x-transition leave-absolute hide-on-leave>
      <div class="px-4" style="margin-top: 29%;" v-if="isShowForm">
        <p class="text-center">
          กรุณาตรวจสอบข้อมูลที่ใบรับประกันสินค้า<br />(ตัวอย่างจดหมายเลขประกัน)
        </p>
        <div class="mb-6">
          <img
            :src="require('@/assets/images/lamy-crm-warranty.png')"
            style="width: 100%; height: auto;"
          />
        </div>

        <!-- Accumulate Form -->
        <div>
          <ValidationObserver ref="observer">
            <div class="py-3">
              <ValidationProvider
                :rules="{
                  required: true,
                }"
                name="ท่านได้รับสินค้านี้จากการซื้อสินค้าหรือเป็นของขวัญ ?"
                v-slot="{ errors }"
              >
                <div class="primary--text">
                  ท่านได้รับสินค้านี้จากการซื้อสินค้าหรือเป็นของขวัญ ?<span
                    class="red--text"
                  >
                    *</span
                  >
                </div>
                <v-radio-group
                  color="primary"
                  :error-messages="errors"
                  v-model="input.productType"
                  row
                >
                  <!-- :disabled="input.productType? true : false" -->
                  <v-radio label="ซื้อสินค้า" value="ซื้อสินค้า"></v-radio>
                  <v-radio label="ของขวัญ" value="ของขวัญ"></v-radio>
                </v-radio-group>
              </ValidationProvider>
            </div>

            <!-- Button for add more product  -->
            <div class="mb-6">
              <v-btn
                :disabled="input.productType == '' ? true : false"
                @click="showAddProductModal = true"
                tile
                color="#555"
                style="width: 100%; height: 48px; color: #FFF;"
              >
                <v-icon left>mdi-plus</v-icon>
                <span style="font-size: 16px;">เพิ่มสินค้า</span>
              </v-btn>
              <!-- <div class="primary--text text-center mt-3">(กรณีสินค้ามากกว่า 1 ชิ้น)</div> -->
            </div>

            <div v-if="input.products.length > 0">
              <p class="primary--text">รายการสินค้าที่ต้องการลงทะเบียน</p>
              <template v-for="(item, i) in input.products">
                <v-card :key="i" class="pt-4 pb-2 px-4 mb-4">
                  <p>
                    <span class="primary--text">หมายเลขรับประกัน :</span>
                    {{ item.warranty_number }}
                  </p>
                  <p>
                    <span class="primary--text">รหัสรุ่นสินค้า :</span>
                    {{ item.sku }}
                  </p>
                  <p>
                    <span class="primary--text">ราคาสินค้า :</span>
                    {{ item.amounts | numberCurrency }} บาท
                  </p>
                </v-card>
              </template>
            </div>

            <!-- :rules="{
                required: true,
              }" -->
            <template
              v-if="input.productType && input.productType !== 'ของขวัญ'"
            >
              <ValidationProvider
                name="สาขา"
                v-slot="{ errors }"
                :rules="{
                  required: true,
                }"
              >
                <div class="primary--text">
                  สาขา <span class="red--text"> *</span>
                </div>
                <v-autocomplete
                  v-model="input.branch"
                  :items="allBranchList"
                  :error-messages="errors"
                  placeholder="เลือกสาขา"
                  style="margin-bottom: 0 !important;"
                  :hide-details="errors ? true : false"
                ></v-autocomplete>
              </ValidationProvider>
              <div v-if="input.branch == 'Other'" class="pt-4">
                <ValidationProvider
                  name="กรอกสาขา"
                  v-slot="{ errors }"
                  :rules="{
                    required: true,
                  }"
                >
                  <div class="primary--text pt-3">
                    กรอกสาขา <span class="red--text"> *</span>
                  </div>
                  <custom-input
                    v-model="input.other_branch"
                    :error-messages="errors"
                    placeholder="กรอกสาขา"
                  ></custom-input>
                  <div
                    style="font-size: 12px; color: #b71c1c !important;"
                    v-if="errors"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>

              <ValidationProvider
                name="ยอดซื้อสินค้าทั้งหมด"
                v-slot="{ errors }"
              >
                <div class="primary--text pt-4">
                  ยอดซื้อสินค้าทั้งหมด <span class="red--text"> *</span>
                </div>
                <custom-input
                  disabled
                  v-model="input.totalPurchase"
                  :error-messages="errors"
                  placeholder="ยอดซื้อสินค้าทั้งหมด"
                ></custom-input>
              </ValidationProvider>

              <!-- :rules="{
                required: true,
              }" -->
              <ValidationProvider
                name="วันที่ซื้อสินค้า"
                v-slot="{ errors }"
                :rules="{
                  required: true,
                }"
              >
                <div class="primary--text pt-4">
                  วันที่ซื้อสินค้า <span class="red--text"> *</span>
                </div>
                <BirthdayPicker v-model="input.receiptDate">
                  <custom-input
                    :value="
                      input.receiptDate
                        ? moment(input.receiptDate)
                            .add(543, 'year')
                            .format('DD/MM/YYYY')
                        : ''
                    "
                    placeholder="DD/MM/YYYY"
                    readonly
                    appendOuterIcon="mdi-calendar"
                    :error-messages="errors"
                  ></custom-input>
                </BirthdayPicker>
              </ValidationProvider>
              <ValidationProvider
                name="Upload ใบเสร็จจากการซื้อสินค้า"
                v-slot="{ errors }"
                :rules="{
                  required: true,
                }"
              >
                <div class="primary--text py-4">
                  Upload ใบเสร็จจากการซื้อสินค้า
                  <span class="red--text"> *</span>
                </div>

                <UploadDocument
                  v-model="input.receiptImage"
                  :background="require(`@/assets/images/icon-upload.png`)"
                  :isProfileImage="false"
                >
                  <template v-slot="props">
                    <custom-input
                      :loading="props.loading"
                      :value="props.filename"
                      prepend-icon="mdi-attachment"
                      readonly
                      :error-messages="errors"
                    ></custom-input>
                  </template>
                </UploadDocument>
                <div
                  style="font-size: 12px; color: #b71c1c !important;"
                  v-if="errors"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </template>
          </ValidationObserver>

          <!-- Button -->
          <v-layout>
            <v-flex xs12>
              <v-btn
                :loading="saveloading"
                @click="submitForm"
                tile
                :disabled="input.products.length == 0 ? true : false"
                :color="input.products.length > 0 ? '#000' : '#CCC'"
                style="width: 100%; height: 48px; margin-bottom: 8px; color: #FFF;"
              >
                <span style="font-size: 16px;">ยืนยัน</span>
              </v-btn>
            </v-flex>
          </v-layout>

          <!-- Modal Add Product -->
          <v-dialog width="350px" v-model="showAddProductModal" persistent>
            <template>
              <AccumulateProductModal
                :productType="input.productType"
                @addProduct="addProduct"
                @close="showAddProductModal = false"
              >
              </AccumulateProductModal>
            </template>
          </v-dialog>
        </div>
      </div>

      <!-- Show result after submit form -->
      <div
        v-else
        class="d-flex align-center"
        style="padding: 0 16px; position: relative; height: 100%; max-height: calc(100vh - 131px);"
      >
        <div class="text-center" style="width: 100%;">
          <template v-if="isSuccess">
            <v-avatar size="62" color="#FFF" style="border: 4px solid #000;">
              <v-icon dark x-large color="green">
                mdi-check
              </v-icon>
            </v-avatar>
            <div style="font-size: 18px;" class="py-6">สะสมยอดซื้อสำเร็จ</div>
            <div>
              ขอบคุณสำหรับการซื้อสินค้า LAMY<br />ยอดซื้อสะสมจะถูกบันทึก
              เมื่อเจ้าหน้าที่ได้ทำการตรวจสอบแล้ว
            </div>
          </template>
          <template v-else>
            <v-avatar size="62" color="#FFF" style="border: 4px solid #000;">
              <v-icon dark x-large color="red">
                mdi-close
              </v-icon>
            </v-avatar>
            <div style="font-size: 18px;" class="py-6">
              สะสมยอดซื้อไม่สำเร็จ
            </div>
          </template>
        </div>
        <div
          style="
          position: absolute;
          bottom: 0px;
          width: 100%;
          left: 0;
          padding: 0 16px;
          padding-bottom: 24px;"
        >
          <v-btn
            tile
            dark
            color="#000"
            @click="changePage('benefits')"
            style="width: 100%; height: 48px; font-size: 18px;"
          >
            {{ isSuccess ? "ตกลง" : "ย้อนกลับ" }}
          </v-btn>
        </div>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import moment from "moment";
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import UploadDocument from "@/components/UploadSingleFile.vue";
import AccumulateProductModal from "./AccumulateProductModal.vue";

export default {
  data() {
    return {
      saveloading: false,
      input: {
        warrantyNumber: "",
        sku: "",
        products: [],
        productType: "",
        price: "",
        branch: "",
        other_branch: "",
        totalPurchase: "",
        receiptDate: "", // YYYY-MM-DD
        receiptImage: "", // url รูปใบเสร็จที่อัปโหลด
      },
      isShowForm: true,
      isSuccess: false,
      remark: "",
      showAddProductModal: false,
      allBranchList: [
        "B2S Central Bangna",
        "B2S Central Chaengwattana",
        "B2S Central Chidlom",
        "B2S Central Ladprao",
        "B2S Central Pattaya",
        "B2S Central Phuket",
        "B2S Central Pinklao",
        "B2S Central Plaza Chiangmai",
        "B2S Central Plaza East Ville",
        "B2S Central Plaza Rama 9",
        "B2S Central Plaza Salaya",
        "B2S Central Plaza Westgate",
        "B2S Central Rama 2",
        "B2S Central Rama 3",
        "B2S Central Rungsit",
        "B2S Central Silom Complex",
        "B2S Central Udonthani",
        "B2S Central World Plaza",
        "B2S CPN Ayutthaya",
        "B2S CPN Chanthaburi",
        "B2S CPN Hadyai",
        "B2S CPN Mahachai",
        "B2S CPN Phitsanulok",
        "B2S CPN Rayong",
        "B2S CPN Samui",
        "B2S CPN Sriracha",
        "B2S Mega Bangna",
        "B2S Online",
        "B2S Rangsit (RBS)",
        "B2S Robinson Bangrak",
        "B2S Robinson Chiangrai",
        "B2S Robinson Chonburi",
        "B2S Robinson Khonkaen",
        "B2S Robinson Rungsit",
        "B2S Robinson Samutprakan",
        "B2S Robinson Saraburi",
        "B2S Robinson Srinakarin",
        "B2S Robinson Srisaman",
        "B2S Robinson Suphanburi",
        "B2S Robinson Suratthani",
        "B2S Robinson Ubonratchathani 2",
        "B2S Crystal Park Ramintha",
        "B2S The Promenade",
        "B2S Seacon Srinakarin",
        "B2S Seacon Bangkae",
        "B2S CPN Korat",
        "B2S CPN Nakhonpathom",
        "B2S CPN Nakhon Sawan",
        "B2S CPN Pitsanuloke",
        "B2S CPN Rangsit",
        "B2S CPN Westville",
        "Officemate Online",
        "Central Bangna",
        "Central Chidlom",
        "Central Lardprao",
        "Central Pinklao",
        "Emporium",
        "e-Shop (www.lamy.co.th)",
        "LAMY Pop-Up Central World",
        "LAMY Pop-Up Mega Bangna",
        "Lamy Concept Store One Bangkok",
        // "Loft ICON SIAM",
        // "Loft Online",
        // "Loft Siam Discovery",
        "Siam Discovery",
        "Siam Paragon",
        "The Mall Bangkae",
        "The Mall Bangkapi",
        "The Mall Ngamwongwan",
        "The Mall Ratchasima",
        "The Mall Thapra",
        "Other",
      ],
    };
  },
  components: {
    Header,
    UploadDocument,
    BirthdayPicker,
    AccumulateProductModal,
  },
  computed: {
    moment() {
      return moment;
    },
  },
  methods: {
    async submitForm() {
      if (await this.$refs.observer.validate()) {
        var branch = "";
        if (this.input.branch == "eShop (www.lamy.co.th)") {
          branch = "eShop";
        } else {
          branch = this.input.branch;
        }

        var data = {
          member_id: this.$store.state.member.id,
          userid: this.$store.state.userid,
          pageid: this.$store.state.pageid,
          name: this.$store.state.member.name,
          phone_number: this.$store.state.member.phone_number,
          products: this.input.products,
          shop_via: branch,
          other_branch: this.input.other_branch,
          receipt: this.input.receiptImage,
          total_purchase: this.input.totalPurchase,
          receipt_timestamp: this.input.receiptDate,
        };
        this.saveloading = true;

        axios
          .post(this.serverUrl + "lamy/rewardPoints", data, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.isShowForm = false;
              this.isSuccess = true;
            } else if (response.data.responsecode == 204) {
              this.isShowForm = false;
              this.isSuccess = false;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonColor: "#000",
              });
              this.$liff.closeWindow();
            }
          });
      }
    },

    addProduct(value) {
      this.input.products.push(value);

      var total = 0;
      if (this.input.products.length > 0) {
        this.input.products.forEach((val) => {
          total += parseFloat(val.amounts);
        });
      }
      this.input.totalPurchase = total;
    },
    changePage(name) {
      var path = "/" + name;
      if (this.$route.path !== path) {
        this.$router
          .push({
            path: name,
            query: { ...this.$route.query },
          })
          .catch({});
      }
    },
  },
  filters: {
    numberCurrency: function(value) {
      var formatter = new Intl.NumberFormat({
        style: "currency",
      });

      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  padding-top: 0 !important;
  // margin-bottom: 24px !important;
}
.v-input--selection-controls {
  margin-top: 0 !important;
}
</style>
